<template>
  <div>  
    <PuzzleCaptchaComponent   @complete="validacaptcha" v-if="!mustraForm && cargando && !token" /> 
    <FormInicialComponent v-if="mustraForm" :numberform="numberForm"  /> 
  </div>
</template>

<script> 
const muestra = sessionStorage.getItem('mustraForm');
import FormInicialComponent from './FormInicial.vue'
import PuzzleCaptchaComponent from './puzzleCaptcha.vue' 
export default {
  name: 'HomePage',
  components: { FormInicialComponent, PuzzleCaptchaComponent },
  props: {
    msg: String
  },
  data() {
    return {
      cargando: false,
       imageUrl: null,
       mustraForm: false,
       numberForm:1,
       token: null
    };
  },
  mounted() { 
    if(!muestra){ 
      this.cargando = true;
    } 
    setTimeout(() => { 
      this.token = this.$route.query.token;
      if(this.token && this.token!=''){ 
        this.mustraForm = true;
        this.numberForm = 2;
      }
    }, 10);
    this.mustraForm = muestra; 
  },
  methods: {
    validacaptcha(e) {
      this.mustraForm = e;
      sessionStorage.setItem('mustraForm', e);
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
